import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bc3c029&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1bc3c029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3c029",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc3c029')) {
      api.createRecord('1bc3c029', component.options)
    } else {
      api.reload('1bc3c029', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bc3c029&scoped=true&", function () {
      api.rerender('1bc3c029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/key-attributes/index.vue"
export default component.exports